/**
 * AB实验页面
 */

export default {
  dbl_ab_experiment_title: "A/B Test Analysis",
  dbl_ab_experiment_calculate: "Calculate",
  dbl_ab_experiment_finish_calculate: "Termination",
  dbl_ab_experiment_not_empty_metric: "Metrics cannot be empty",
  dbl_ab_experiment_clear: "Clear",
  dbl_ab_experiment_global_filter_title: "General Filter",
  dbl_ab_experiment_event_filter_title: "Event Filter",
  dbl_ab_experiment_experiment_cascade_title: "Experiment Filter",
  dbl_ab_experiment_metric_filter_title: "Metric",
  dbl_ab_experiment_dimension_filter_title: "Dimension",
  dbl_ab_experiment_observation_settings_title: "Observation Settings",
  dbl_ab_experiment_observation_days: "Observation Days",
  dbl_ab_experiment_observation_days_exceeds_max: "Exceeds maximum (max is {max})",
  dbl_ab_experiment_limit: "Limit",
  dbl_ab_experiment_global_filter_add_button: "Add General Filter",
  dbl_ab_experiment_event_filter_add_button: "Add Event Filter",
  dbl_ab_experiment_experiment_cascade_add_button: "Add Experiment Filter",
  dbl_ab_experiment_experiment_cascade_remove_filter: "Remove filter",
  dbl_ab_experiment_metric_filter_add_button: "Add Metric",
  dbl_ab_experiment_metric_filter_add_custom_button: "Add Custom Metric",
  dbl_ab_experiment_metric_filter_custom_placeholder: "Please select custom metric",
  dbl_ab_experiment_dimension_filter_add_button: "Add Dimension",
  dbl_ab_experiment_event_filter_placeholder: "Please select event",
  dbl_ab_experiment_event_filter_placeholder_all_event: "All Event",
  dbl_ab_experiment_event_filter_edit_name: "Edit Name",
  dbl_ab_experiment_event_filter_delete: "Delete",
  dbl_ab_experiment_user_type_title: "User Type",
  dbl_ab_experiment_user_type_active_user: "Active User",
  dbl_ab_experiment_user_type_new_user: "New User",
  dbl_ab_experiment_user_type_old_user: "Old User",
  dbl_ab_experiment_date_range_title: "Date Range",
  dbl_ab_experiment_abtest_cascader_experiment_layer: "Experiment Layer",
  dbl_ab_experiment_abtest_cascader_experiment_name: "Experiment Name",
  dbl_ab_experiment_abtest_cascader_experiment_group: "Experiment Group",
  dbl_ab_experiment_abtest_cascader_placeholder: "Please select experiment",
  dbl_ab_experiment_abtest_cascader_search_placeholder: "Search",
  dbl_ab_experiment_event_occur_label: "Event Occur",
  dbl_ab_experiment_event_occur_placeholder: "Please select",
  dbl_ab_experiment_event_occur_option_event_count: "Number of occurrences",
  dbl_ab_experiment_event_occur_option_user_count: "Number of people involved",
  dbl_ab_experiment_event_occur_option_reach_rate: "Reach rate",
  dbl_ab_experiment_event_occur_count_label: "Event Occur Count",
  dbl_ab_experiment_event_occur_count_error: "Enter integers and max must be ≥ min",
  dbl_ab_experiment_event_occur_operator_placeholder: "Select condition",
  dbl_ab_experiment_empty_guide_title: "Operation Guide:",
  dbl_ab_experiment_empty_guide_step1: "1. Please select metrics in the left area and set the observation days.",
  dbl_ab_experiment_empty_guide_step2: "2. (Optional) Set general filters, event filters, experiment filters, and dimensions as needed.",
  dbl_ab_experiment_empty_guide_step3: "3. After configuration is complete, click [Calculate].",
  dbl_ab_experiment_calculate_error: "Calculation failed, error code {code}",
  dbl_ab_experiment_load_task_error: "Failed to load task details, error code {code}",
  dbl_ab_experiment_leave_info: "Leave the current analysis task?",
  dbl_ab_experiment_preview_sql: "Preview SQL",
  dbl_ab_experiment_preview_sql_copy: "Copy",
  dbl_ab_experiment_preview_sql_fail: "Preview SQL failed",
  dbl_ab_experiment_preview_sql_fail_with_code: "Preview SQL failed, error code {code}",
};
